module.exports = __webpack_public_path__ + "static/media/LightsonWonderRockBookCover.03f43bc8.jpg";